<template>
	<div class="introduction">
		<modal-box v-if="modalBox.open" @close="onModalBoxClose" header="Introduction">
			<p>You have free {{ budget.data.current }}€. Do you want to subscribe Idicare service?</p>
			<button @click="onClick" class="btn btn-primary btn-round">SUBSCRIBE</button>
		</modal-box>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
export default {
	data () {
		return {
			budget: new ApiObject(),
			modalBox: {
				open: false
			}
		}
	},
	methods: {
		onModalBoxClose () {
			this.modalBox.open = false
		},
		onShow (user_uid) {
			this.getBudget(user_uid)
		},
		onClick () {
			this.modalBox.open = false
			this.$router.push({ name: 'UserProfileSubscriptionsSubscriptions' })
		},
		getBudget (user_uid) {
			this.budget.loading = true
			this.$api.subscriptions.budgets.get(this, user_uid)
				.then(response => {
					this.$log.info('intro', 'subscriptions.budgets.get OK', response)()
					this.budget.data = response.body
					if (this.budget.data.current == 100) {
						this.modalBox.open = true
					}
				}).catch(error => {
					this.$log.error('intro', 'subscriptions.budgets.get ERROR', error)()
					this.budget.error = error
				}).finally(() => {
					this.budget.loading = false
				})
		}
	},
	mounted () {
		this.$root.$on('show-introduction', this.onShow)
	},
	beforeDestroy () {
		this.$root.$off('show-introduction', this.onShow)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/intro/Introduction.vue